import styled from '@emotion/styled';
import { N20A } from '@atlaskit/theme/colors';
export var SkeletonText = styled.span({
  display: 'inline-block',
  height: '1em',
  borderRadius: '0.5em',
  backgroundColor: "var(--ds-background-neutral, ".concat(N20A, ")")
}, function (_ref) {
  var length = _ref.length;
  return {
    width: length
  };
});